import React from 'react';
import styles from './UIGamePlayerInfoSection.module.scss';
export const UIGamePlayerInfoSection = ({ children })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, children);
